// "username · Type" label for a marketplace account.

export const TYPE_NAMES = {
  poshmark: "Poshmark",
  ebay: "eBay",
  mercari: "Mercari",
  depop: "Depop",
  medusa: "Medusa",
  shopify: "Shopify",
};

function typeName(type) {
  const t = String(type || "").toLowerCase();
  if (!t) return "";
  return TYPE_NAMES[t] || t.charAt(0).toUpperCase() + t.slice(1);
}

export function displayName(username) {
  const u = String(username || "").trim();
  if (/^https?:\/\//i.test(u)) {
    try {
      return new URL(u).hostname;
    } catch (e) {
      return u;
    }
  }
  return u;
}

export function accountLabel(account) {
  if (!account) return "Unknown account";
  const name = displayName(account.username);
  const type = typeName(account.type);
  if (name && type) return `${name} · ${type}`;
  return name || type || "Unknown account";
}
